import { ModalComponent } from "../..";
import { formatDate, formatToCurrency } from "../../../../helperFunctions";
import { SingleGeneratedSchedule } from "../../../../redux/features/loans/loans.type";
import { TableComponent } from "../../../table/table";

export const LoanRepaymentScheduleGeneratedModal = ({
  isModalOpen,
  onModalClose,
  schedule,
}: {
  isModalOpen: boolean;
  onModalClose: () => void;
  schedule: SingleGeneratedSchedule[];
}) => {
  return (
    <>
      <ModalComponent
        isModalOpen={isModalOpen}
        onModalClose={() => {
          onModalClose();
        }}
        title={`Repayment Schedule`}
        topTitle
        subTitle=""
        childrenClassName="flex flex-col gap-6"
        modalClassName="!min-h-[572px] !max-w-[1038px]"
        hasButtons={false}
      >
        <TableComponent
          className="w-full !min-w-max md:!min-w-full"
          isRowClickable={false}
          mobileCardView
          headers={["Due Date", "Repayment Amount", "Principal", "Interest"]}
          isLoading={false}
          headerClassName="!bg-white"
          isTableEmpty={[0, undefined].includes(schedule.length)}
          isPaginated={false}
          emptrySrc="/assets/images/empty_state_cooperatives.svg"
          emptyTitle="No Schedule Found"
          totalCount={schedule.length}
          rows={
            schedule.map((item, idx) => {
              return {
                id: idx,
                items: [
                  formatDate(item.due_date),
                  formatToCurrency(item.amount_due, {
                    decimalPlaces: 2,
                    currency: "NGN",
                  }),
                  formatToCurrency(item.principal_due, {
                    decimalPlaces: 2,
                    currency: "NGN",
                  }),
                  formatToCurrency(item.interest_due, {
                    decimalPlaces: 2,
                    currency: "NGN",
                  }),
                ],
              };
            }) ?? []
          }
        />
      </ModalComponent>
    </>
  );
};
